import * as React from 'react';

const RadioInput: React.SFC<React.InputHTMLAttributes<HTMLInputElement>> = inputProps => {
  return <input type="radio" {...inputProps} />;
};

export default RadioInput;
